/* eslint-disable react/no-array-index-key */
import React from 'react';
import dayjs from 'dayjs';
import styles from '../pages/NewAgreementSecondPage/NewAgreementSecondStep/styles.module.scss';
import { Input } from '../components/simple';
import { translate } from '../localization/LanguageContext';

const day = dayjs().format('YYYY-MM-DD');

const stepCreator = (label, name, type, readonly, min, placeholder) => ({
  label,
  name,
  type,
  readonly,
  min,
  placeholder,
});

export const firstStepValues = [
  stepCreator(translate('company_name'), 'name', 'text'),
  stepCreator(translate('organization_number'), 'organization_number', 'text'),
  stepCreator(translate('date'), 'date', 'text', true),
  stepCreator(translate('postal_address'), 'postal_address', 'text'),
  stepCreator(translate('zip_code'), 'zip_code', 'text'),
  stepCreator(translate('place'), 'state', 'text'),
  // stepCreator('Land:', 'country', 'text'),
  stepCreator(translate('phone_number'), 'phone_number', 'text'),
  stepCreator(translate('offer_valid_period'), 'expire', 'date', null, day),
];

export const secondStepValues = {
  signers: {
    label: `${translate('company_signatory')}:`,
    items: [
      stepCreator(translate('first_last_name'), 'name', 'text'),
      stepCreator(translate('email'), 'email', 'text'),
      stepCreator(translate('mobile_number'), 'phone_number', 'text'),
      stepCreator(translate('social_security_number'), 'social_security_number', 'text'),
    ],
  },
  telephone_manager: {
    label: `${translate('telephone_manager')}:`,
    items: [
      stepCreator(translate('first_last_name'), 'name', 'text'),
      stepCreator(translate('email'), 'email', 'text'),
      stepCreator(translate('mobile_number'), 'phone_number', 'text'),
    ],
  },
  real_principals: {
    label: `${translate('real_principal')}:`,
    items: [
      stepCreator(translate('first_last_name'), 'name', 'text'),
      stepCreator(translate('email'), 'email', 'text'),
      stepCreator(translate('mobile_number'), 'phone_number', 'text'),
      stepCreator(translate('social_security_number'), 'social_security_number', 'text'),
      stepCreator(`${translate('real_principal')} 1:`, 'percentage', 'text', null, null, 'Ägarandel i %'),
    ],
  },
  manager: {
    label: `${translate('seller')}:`,
    items: [
      stepCreator(translate('first_last_name'), 'username', 'text'),
      stepCreator(translate('email'), 'email', 'text'),
      stepCreator(translate('mobile_number'), 'phone_number', 'text'),

      stepCreator(translate('company_name'), 'partner_name', 'text'),
      stepCreator(translate('organization_number'), 'partner_org_num', 'text'),
    ],
  },
};

export const checkboxValues = {
  copyInfo: [
    stepCreator(translate('copy_to_real_principal'), 'copyManager'),
    stepCreator(translate('copy_to_telephone_manager'), 'copyPrincipal'),
  ],
  addPerson: [stepCreator(translate('add_principal'), 'addPrincipal')],
};

export const selectValues = [12, 24, 36, 48, 60];
export const selectValuesPingPro = [0, 12, 24, 36, 48, 60];

export const formCreator = (value, formik) =>
  secondStepValues[value].items.map((input) => (
    <div className={styles.inputWrapper} key={input.name}>
      <Input
        name={`${value}.${input.name}`}
        label={input.label}
        type={input.type}
        onChange={formik.handleChange}
        value={formik.values[value][input.name] || ''}
        className={`${styles.input} ${formik.touched[value] && formik.errors[value] && styles.errorInput}`}
        labelStyle={styles.label}
        placeholder={input.placeholder}
      />
      {formik.touched[value] && formik.errors[value] && (
        <div className={styles.error}>{formik.errors[value][input.name]}</div>
      )}
    </div>
  ));

export const formListCreator = (value, formik, title, renderCheckBox, renderTitle = null, filter = (v) => v) => {
  // eslint-disable-next-line prefer-destructuring
  const items = secondStepValues[value].items;

  return formik.values[value].map((item, index) => (
    <div className={styles.copyPrincipal} key={index}>
      <h2 className={styles.title}>{renderTitle?.(item, index) || title} </h2>
      <div className={styles.realPrincipalBlock}>
        <div className={styles.principalInputs}>
          {items
            .filter((t) => filter(t, item))
            .map((input) => (
              <div className={styles.inputWrapper} key={input.name}>
                <Input
                  name={`${value}.${index}.${input.name}`}
                  label={input.label}
                  type={input.type}
                  onChange={formik.handleChange}
                  value={formik.values[value][index][input.name] || ''}
                  className={`${styles.input} ${formik.touched[value] && formik.errors[value] && styles.errorInput}`}
                  labelStyle={styles.label}
                  placeholder={input.placeholder}
                />
                {formik.touched[value] && formik.errors[value] && (
                  <div className={styles.error}>{formik.errors?.[value]?.[input?.name]}</div>
                )}
              </div>
            ))}
        </div>
        {renderCheckBox?.(index, item)}
      </div>
    </div>
  ));
};
